import { useContext, useState } from 'react';
import clsx from 'clsx';

import { isFilterableDataType } from '@atom/components/common/workOrdersFilters/fieldFilterUtilities';
import TaskFieldFilterInput from '@atom/components/common/workOrdersFilters/TaskFieldFilterInput';
import { Icon, IconButton } from '@atom/mui';
import { KeyboardArrowDownIcon, KeyboardArrowUpIcon } from '@atom/mui/icons';
import { FieldFilter } from '@atom/types/work';
import { isNilOrEmpty } from '@atom/utilities/validationUtilities';
import { isCascadingField } from '@atom/utilities/workOrderFieldUtilities';

import WorkOrdersFiltersContext, {
  TasksAdditionalFieldFilters,
} from './WorkOrdersFiltersContext';

import classes from './filters.module.css';

const WorkTemplateTaskFieldsFilter = () => {
  const [collapsed, setCollapsed] = useState<{ [taskId: string]: boolean }>({});

  const {
    areFiltersDisabled,
    filterForm,
    workOrderTemplate,
    updateFilterForm,
  } = useContext(WorkOrdersFiltersContext);

  const { workTemplateTaskFields } = filterForm;

  const onCollapse = (taskId: string) =>
    setCollapsed(current => ({ ...current, [taskId]: !current[taskId] }));

  const onFieldFilterChange = (taskId: string, updatedFilter: FieldFilter) =>
    updateFilterForm(
      'workTemplateTaskFields',
      (current: TasksAdditionalFieldFilters) => ({
        ...current,
        [taskId]: {
          ...current[taskId],
          [updatedFilter.id]: updatedFilter,
        },
      }),
    );

  return (
    <>
      {workOrderTemplate?.tasks?.map(task =>
        !isNilOrEmpty(task?.fields) ? (
          <div key={task.id}>
            <div
              className={clsx(
                classes.header,
                classes.filterSectionHeader,
                classes.filterContainer,
              )}
            >
              <div>{task.name}</div>
              <IconButton
                onClick={() => onCollapse(task.id)}
                edge="end"
                data-cy={`workOrdersFilterTaskFieldsCollapseButton-${task.name}`}
              >
                <Icon
                  icon={
                    collapsed[task.id]
                      ? KeyboardArrowDownIcon
                      : KeyboardArrowUpIcon
                  }
                />
              </IconButton>
            </div>
            {!collapsed[task.id] &&
              (task.fields || [])
                .filter(
                  field =>
                    !isCascadingField(field) &&
                    isFilterableDataType(field.dataType),
                )
                .map(field => (
                  <div className={classes.filterContainer} key={field.id}>
                    <TaskFieldFilterInput
                      field={field}
                      fieldFilter={workTemplateTaskFields[task.id]?.[field.id]}
                      onChange={updatedFilter =>
                        onFieldFilterChange(task.id, updatedFilter)
                      }
                      disabled={areFiltersDisabled}
                      dataCy={`workOrdersFilterTaskField-${task.name}-${field.title}`}
                    />
                  </div>
                ))}
          </div>
        ) : (
          <div key={task.id} />
        ),
      )}
    </>
  );
};

export default WorkTemplateTaskFieldsFilter;
